import "./Errors.scss"
import JSError from "./components/JSError";
import DefaultError from "./components/DefaultError";
import UnauthorisedError from "./components/UnauthorisedError";
import BadRequestError from "./components/BadRequestError";
import PageNotFoundError from "./components/PageNotFoundError";
import InternalServerError from "./components/InternalServerError";

interface ErrorsProps {
    errorCode: number
}

const Errors = (props: ErrorsProps) => {
    switch (props.errorCode) {
        case 400: return <BadRequestError />
        case 401:
        case 403: return <UnauthorisedError />
        case 404: return <PageNotFoundError />
        case 500: return <InternalServerError />
        case 0: return <JSError isModal />
        default: return <DefaultError errorCode={props.errorCode} />
    }
};

export default Errors;
